<div class="top-btn-row d-flex align-items-center mb-1">
  <app-button
    [buttonSize]="'history'"
    [buttonStyle]="'secondary'"
    (click)="goBack()"
    ><i class="fas fa-chevron-left me-2"></i>Go back</app-button
  >
  <div class="d-flex justify-content-center w-100">
    <div class="summary-button" (click)="toggleInfo()">
      {{ isShow ? "Hide Summary" : "Show Summary" }}
      <i
        class="fal"
        [ngClass]="{ 'fa-chevron-up': isShow, 'fa-chevron-down': !isShow }"
      ></i>
    </div>
  </div>
  <div class="skusNotMapped mt-0 text-nowrap" *ngIf="skusNotMapped?.length && headerService.useBinLocation" (click)="openDialogForSkus()">
    <span class="skusNotMapped-count">
        <i class="far fa-bell me-1"></i>
        <span class="skusNotMapped-count_number">{{skusNotMapped?.length || 0}}</span>
    </span>
    <span>{{skusNotMapped?.length || 0}} Items out of stock</span>
</div>
</div>
<div
  class="shippinginfo"
  [ngClass]="isShow ? 'collapseshow' : 'collapsehide'"
  *ngIf="shipmentDetail"
>
  <ul class="shippinginfo_list">
    <li>
      <label class="label_text d-flex align-items-center">Shipment name<app-button *ngIf="accountType == 'Amazon'"  (click)="editWarehouse(true)" [buttonStyle]="'text'" [buttonSize]="'action'">Edit</app-button></label>
      <span class="value">{{
        shipmentDetail.shipmentName
          ? shipmentDetail.shipmentName
          : shipmentDetail.status + ":" + shipmentDetail.shipmentHeaderId
      }}</span>
      <label class="label_text mt-11">Shipment ID</label>
      <span class="value">{{
        shipmentDetail.amazonShipmentId ? shipmentDetail.amazonShipmentId : "_"
      }}</span>
      <a class="shipment_relatedShipment pointer" *ngIf="shipmentDetail.relatedShipment" (click)="getRelatedShipments($event)">{{ shipmentDetail.relatedShipment }} Related Shipments<i class="fas fa-chevron-down ml-1 font_size_10"></i></a>
      <ng-container *ngIf="accountType == 'Amazon'">
        <label class="label_text mt-11">Shipping Price <app-button (click)="editWarehouse(false,false,true)" [buttonStyle]="'text'" [buttonSize]="'action'">Edit</app-button></label>
        <span class="value">{{(shipmentDetail.shipingPrice || 0) | currency}}</span>
      </ng-container>   
    </li>
    <li>
      <label class="label_text d-flex align-items-center">Ship from<app-button *ngIf="accountType == 'Amazon'" (click)="editWarehouse()" [buttonStyle]="'text'" [buttonSize]="'action'">Edit</app-button></label>
      <span class="value" *ngIf="!shipmentDetail?.sourceWarehouse">_</span>
      <div *ngIf="shipmentDetail?.sourceWarehouse">
        <span class="value">{{ shipmentDetail?.sourceWarehouse?.code }}</span>
        <span class="value">{{
          shipmentDetail?.sourceWarehouse?.addressLine1
        }}</span>
        <span class="value"
          >{{ shipmentDetail?.sourceWarehouse?.city }},&nbsp;{{
            shipmentDetail?.sourceWarehouse?.state
          }},&nbsp;{{ shipmentDetail?.sourceWarehouse?.postal }}</span
        >
        <span class="value">{{
          shipmentDetail?.sourceWarehouse?.countryCode
        }}</span>
      </div>
    </li>
    <li>
      <label class="label_text d-flex align-items-center">Deduct from<app-button *ngIf="(accountType == 'Amazon' || accountType == 'Walmart') && !shipmentDetail.isComplete" (click)="editWarehouse(false,true)" [buttonStyle]="'text'" [buttonSize]="'action'">Edit</app-button></label>
      <span class="value" *ngIf="!shipmentDetail?.deductFromWarehouse">_</span>
      <div *ngIf="shipmentDetail?.deductFromWarehouse">
        <span class="value">{{ shipmentDetail?.deductFromWarehouse?.code }}</span>
        <span class="value">{{
          shipmentDetail?.deductFromWarehouse?.addressLine1
        }}</span>
        <span class="value"
          >{{ shipmentDetail?.deductFromWarehouse?.city }},&nbsp;{{
            shipmentDetail?.deductFromWarehouse?.state
          }},&nbsp;{{ shipmentDetail?.deductFromWarehouse?.postal }}</span
        >
        <span class="value">{{
          shipmentDetail?.deductFromWarehouse?.countryCode
        }}</span>
      </div>
    </li>
    <li>
      <label class="label_text">Ship to</label>
      <span class="value">{{ shipmentDetail?.destinationWarehouse.code }}</span>
      <span class="value">{{
        shipmentDetail?.destinationWarehouse.addressLine1
      }}</span>
      <span class="value"
        >{{ shipmentDetail?.destinationWarehouse.city }},&nbsp;{{
          shipmentDetail?.destinationWarehouse.state
        }},&nbsp;{{ shipmentDetail?.destinationWarehouse.postal }}</span
      >
      <span class="value">{{
        shipmentDetail?.destinationWarehouse.countryCode
      }}</span>
    </li>
    <li>
      <label class="label_text">Shipment content</label>
      <div>
        <span class="value content">
          <label class="label_text">SKUs</label>:
          {{ shipmentDetail.totalSku | number}}</span
        >
        <span class="value content">
          <label class="label_text">Units </label>:
          {{ shipmentDetail.totalUnits | number}}
        </span>
        <span class="value content" *ngIf="accountType !== 'Walmart'">
          <label class="label_text">Boxes </label>:
          {{ (shipmentDetail.totalBox || 0) | number}}
        </span>
        <span class="value content">
          <label class="label_text">Weight(lbs) </label>:
          {{ shipmentDetail.totalWeight  | number: '1.0-0'}}
        </span>
        <span class="value content">
          <label class="label_text">Cu ft</label>:
          {{cubicFeet > 0 ? cubicFeet?.toFixed(2) : 0}}
        </span>
        <span class="value content">
          <label class="label_text">Total Value</label>:
          {{ (shipmentDetail.totalAvgCost || 0) | currency}}</span
        >           
      </div>
    </li>
    <li>
     <div>
      <span class="value content shipment-type-content">
        <label class="label_text">FBA Shipment Type</label>:
        {{ shipmentDetail.shipmentType }}</span
      >
       <span class="value content shipment-type-content">
          <label class="label_text">Created</label>:
          {{ shipmentDetail.dateCreated | date: "mediumDate" }}</span
        >
        <span class="value content shipment-type-content">
          <label class="label_text">Created By</label>:
          {{ shipmentDetail.submittedBy}}</span
        >
        <span class="value content shipment-type-content">
          <label class="label_text">Prep by </label>:
          {{ shipmentDetail.isPrepByAmazon ? 'Amazon' : 'Seller'}}
        </span>
        <div class="" *ngIf="shipmentDetail.boxContentSubmitted != null">
          <label class="label_text me-1">Box Content Submitted </label>:
          <span class="status" [ngClass]="shipmentDetail.boxContentSubmitted ? 'status--success' : 'status--fail'">  
          <i  [ngClass]="{
            'fa fa-check-circle': shipmentDetail.boxContentSubmitted,
            'fas fa-exclamation-circle': !shipmentDetail.boxContentSubmitted
          }"
          ></i>
          {{ shipmentDetail.boxContentSubmitted ? 'Success' : 'Failed'}}
        </span>
      </div>  
      <span class="value content shipment-type-content" *ngIf="shipmentDetail.status !== 'DRAFT'">
        <label class="label_text me-1">Box Content Source </label>
        <span class="d-flex align-items-center">: 
          {{ shipmentDetail.boxContentSource }} <app-button class="edit" (click)="boxContentSource(shipmentDetail.boxContentSource)" [buttonStyle]="'text'" [buttonSize]="'action'">Edit</app-button>
        </span>
      </span>
      <span class="value content shipment-type-content">
          <label class="label_text me-1">Note </label>
          <span class="d-flex align-items-center mt-1" [matTooltip]="shipmentDetail?.userNote">:
            <app-button class="edit" [buttonStyle]="'text'" [buttonSize]="'action'" (click)="openNotePopup()">Edit</app-button>
        </span> 
      </span>
      <span class="value content shipment-type-content align-items-start">
        <label class="label_text me-1">Attachments </label>
        <span class="d-flex align-items-baseline">:
          <form [formGroup]="shipmentDetailForm">
            <div class="box_label d-flex gap-2 ps-2">
              <div class="file-boxupload">
                <input type="file" id="attachmentPath1" formControlName="attachmentPath1" class="file-input"
                  (change)="onFileUpload($event)" #attachmentPath1>
                <div class="file-upload box_attachments d-flex align-items-baseline">
                  <div class="box_attachment pointer d-flex gap-1 flex-column p-0">
                    <div *ngFor="let item of shipmentDetail.shipmentAttachements">
                      <div class="d-flex align-items-center w-100" *ngIf="item.fileName">
                        <span class="box_attachment-span" *ngIf="item.fileName ">
                          <span class="box_attachment-name" (click)="openFile(item.fileName)"
                            [matTooltip]="item.fileName">{{item.fileName}}</span>
                          <span class="box_attachAction" (click)="removeAttachmentFile(item.fileName)" *ngIf="item.fileName">
                            <i class="fal fa-times"></i>
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="text-nowrap" *ngIf="!shipmentDetail.shipmentAttachements.length"> No Files uploaded yet </div>
                  <div class="box_attachment box_attachment--active" (click)="attachmentPath1.click()">
                    <span class="box_attachAction">
                      <i class="fal fa-paperclip hand" ></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </form>
      </span> 
    </span>
      </div>
    </li>
  </ul>
</div>
